import * as React from 'react';
import { FormControl, Grid, FormControlLabel, Checkbox, TextField } from '@material-ui/core';
import { SurveyStatusEnum } from 'src/constants/Enum/SurveyStatusEnum';
import { handleKeyPress } from '../../../constants/commonFunctions';
import WarningIcon from '@material-ui/icons/Warning';
import { updateAdminLevelQuestionDataValue } from 'src/effects/utils/preview';

export default class AdminLevelTypeQuestionComponent extends React.Component<any, any> {

    setLocalState(props: any) {
        const previousStateString = this.state && this.state.questionAdminLevelResponse ? JSON.stringify(this.state.questionAdminLevelResponse) : null;
        const currentStateString = JSON.stringify(props.question);
        if (previousStateString !== currentStateString) {
            this.setState({
                questionAdminLevelResponse: props.question

            });

        }

    }

    componentDidMount() {
        this.setLocalState(this.props);
        if (this.props.pageNumber > 0) {
            this.autoCalculateHorizontal(this.props)
            this.autoCalculateVertical(this.props);
        }
    }

    componentWillReceiveProps(nextProps: any) {
        this.setLocalState(nextProps);
        this.autoCalculateHorizontal(this.props)
        this.autoCalculateVertical(nextProps);
    }

    getQuestionByQuestionId(questionId: any) {
        const questionMetadata = {
            clusterIndex: 0,
            questionIndex: 0,
            question: undefined,
            questionId: 0
        }

        for (const page of this.props.pages) {
            for (let clusterIndex: any = 0; clusterIndex < page.page.question_clusters.length; clusterIndex++) {
                for (let questionIndex: any = 0; questionIndex < page.page.question_clusters[clusterIndex].questions.length; questionIndex++) {
                    const questionData = page.page.question_clusters[clusterIndex].questions[questionIndex];
                    if (questionData && questionData.question_id === questionId) {
                        questionMetadata.clusterIndex = clusterIndex;
                        questionMetadata.questionIndex = questionIndex;
                        questionMetadata.questionId = questionId;
                        questionMetadata.question = questionData;
                        return questionMetadata;
                    }
                }
            }
        }

        return questionMetadata;
    }

    getQuestionResponsesById(questionId: any) {
        const questionMetadata = this.getQuestionByQuestionId(questionId);
        const question = questionMetadata ? questionMetadata.question : undefined;
        const responses = this.getQuestionResponses(question);

        return responses;
    }

    getQuestionResponses(question: any) {          
        if (question) {
            return question.question_admin_responses;
        }
        return; 
    }

    autoCalculateHorizontal(props: any) {
        const autoCalConfig = props.question.auto_calculation_config;
        const adminLevelQuestion = props.question;
        if (autoCalConfig && props.question.class_type === 3) {
            if (autoCalConfig.is_horizontal && autoCalConfig.horizontal_config) {
                if (autoCalConfig.horizontal_config.operator) {
                    const finalAdminLevelResponse: any = JSON.parse(JSON.stringify(props.question.question_admin_responses));


                    if (finalAdminLevelResponse && finalAdminLevelResponse[0]) {
                        switch (autoCalConfig.horizontal_config.operator) {
                            case "+":
                                {

                                    finalAdminLevelResponse[0].forEach((adminLevelResponse: any, adminLevelIndex: number) => {
                                        const operandOne = finalAdminLevelResponse[0] && finalAdminLevelResponse[0][adminLevelIndex] && finalAdminLevelResponse[0][adminLevelIndex].value ? parseInt(finalAdminLevelResponse[0][adminLevelIndex].value, 10) : null;
                                        const operandTwo = finalAdminLevelResponse[1] && finalAdminLevelResponse[1][adminLevelIndex] && finalAdminLevelResponse[1][adminLevelIndex].value ? parseInt(finalAdminLevelResponse[1][adminLevelIndex].value, 10) : null;

                                        if (!operandOne && !operandTwo && finalAdminLevelResponse[2][adminLevelIndex] !==  null) {
                                            finalAdminLevelResponse[2][adminLevelIndex].value = '';
                                        }
                                        if (!operandOne && operandTwo && finalAdminLevelResponse[2][adminLevelIndex] !==  null) {
                                            finalAdminLevelResponse[2][adminLevelIndex].value = operandTwo.toString();
                                        }
                                        if (operandOne && !operandTwo && finalAdminLevelResponse[2][adminLevelIndex] !==  null) {
                                            finalAdminLevelResponse[2][adminLevelIndex].value = operandOne.toString();
                                        }
                                        if (operandOne && operandTwo && finalAdminLevelResponse[2][adminLevelIndex] !==  null) {
                                            finalAdminLevelResponse[2][adminLevelIndex].value = (operandOne + operandTwo).toString();
                                        }
                                    });
                                    adminLevelQuestion.question_admin_responses = finalAdminLevelResponse;                                  
                                }
                                break;
                            case "-":
                                {

                                    finalAdminLevelResponse[0].forEach((adminLevelResponse: any, adminLevelIndex: number) => {
                                        const operandOne = finalAdminLevelResponse[0] && finalAdminLevelResponse[0][adminLevelIndex] && finalAdminLevelResponse[0][adminLevelIndex].value ? parseInt(finalAdminLevelResponse[0][adminLevelIndex].value, 10) : null;
                                        const operandTwo = finalAdminLevelResponse[1] && finalAdminLevelResponse[1][adminLevelIndex] && finalAdminLevelResponse[1][adminLevelIndex].value ? parseInt(finalAdminLevelResponse[1][adminLevelIndex].value, 10) : null;

                                        if (!operandOne && !operandTwo) {
                                            finalAdminLevelResponse[2][adminLevelIndex].value = '';
                                        }
                                        if (!operandOne && operandTwo) {
                                            finalAdminLevelResponse[2][adminLevelIndex].value = operandTwo.toString();
                                        }
                                        if (operandOne && !operandTwo) {
                                            finalAdminLevelResponse[2][adminLevelIndex].value = operandOne.toString();
                                        }
                                        if (operandOne && operandTwo) {
                                            finalAdminLevelResponse[2][adminLevelIndex].value = (operandOne - operandTwo).toString();
                                        }
                                    });

                                    adminLevelQuestion.question_admin_responses = finalAdminLevelResponse;

                                    break;
                                }
                            case "%":
                                {
                                    finalAdminLevelResponse[0].forEach((adminLevelResponse: any, adminLevelIndex: number) => {
                                        const operandOne = finalAdminLevelResponse[0] && finalAdminLevelResponse[0][adminLevelIndex] && finalAdminLevelResponse[0][adminLevelIndex].value ? parseInt(finalAdminLevelResponse[0][adminLevelIndex].value, 10) : null;
                                        const operandTwo = finalAdminLevelResponse[1] && finalAdminLevelResponse[1][adminLevelIndex] && finalAdminLevelResponse[1][adminLevelIndex].value ? parseInt(finalAdminLevelResponse[1][adminLevelIndex].value, 10) : null;

                                        if (operandOne && operandTwo) {
                                            const unroundedValue = (operandOne / operandTwo) * 100;
                                            if (!Number.isNaN(unroundedValue)) {
                                                const rounded = Math.round(unroundedValue * 10) / 10;
                                                finalAdminLevelResponse[2][adminLevelIndex].value = rounded.toFixed(1).toString();
                                            }
                                            else {
                                                finalAdminLevelResponse[2][adminLevelIndex].value = '';
                                            }
                                        }
                                        else {
                                            finalAdminLevelResponse[2][adminLevelIndex].value = '';
                                        }


                                    });

                                    adminLevelQuestion.question_admin_responses = finalAdminLevelResponse;


                                }
                                break;
                            case "%of":
                                {
                                    finalAdminLevelResponse[0].forEach((adminLevelResponse: any, adminLevelIndex: number) => {
                                        const operandOne = finalAdminLevelResponse[0] && finalAdminLevelResponse[0][adminLevelIndex] && finalAdminLevelResponse[0][adminLevelIndex].value ? parseInt(finalAdminLevelResponse[0][adminLevelIndex].value, 10) : null;
                                        const operandTwo = finalAdminLevelResponse[1] && finalAdminLevelResponse[1][adminLevelIndex] && finalAdminLevelResponse[1][adminLevelIndex].value ? parseInt(finalAdminLevelResponse[1][adminLevelIndex].value, 10) : null;

                                        if (operandOne && operandTwo) {
                                            const unroundedValue = (operandOne / 100) * operandTwo;
                                            if (!Number.isNaN(unroundedValue)) {
                                                const rounded = Math.round(unroundedValue * 10) / 10;
                                                finalAdminLevelResponse[2][adminLevelIndex].value = rounded.toFixed(1).toString();
                                            }
                                            else {
                                                finalAdminLevelResponse[2][adminLevelIndex].value = '';
                                            }
                                        }
                                        else {
                                            finalAdminLevelResponse[2][adminLevelIndex].value = '';
                                        }
                                    });
                                    adminLevelQuestion.question_admin_responses = finalAdminLevelResponse;
                                }
                                break;
                        }
                    }
                    const previousQuestion = JSON.stringify(props.question);
                    const updatedQuestion = JSON.stringify(adminLevelQuestion);
                    if (previousQuestion !== updatedQuestion) {
                        this.setState({
                            questionAdminLevelResponse: adminLevelQuestion

                        }, () => {
                            updateAdminLevelQuestionDataValue(this.props, this.state.questionAdminLevelResponse.class_type, false, false, null, true, [], this.state.questionAdminLevelResponse)

                        })

                    }
                }
            }
        }
    }


    autoCalculateVertical(props: any) {
        const autoCalConfig = props.question.auto_calculation_config;
        const adminLevelQuestion = props.question;
        let finalAdminLevelResponse: any = [];

        if (autoCalConfig.vertical_config) {
            const verticalConfig = autoCalConfig.vertical_config;
            if (verticalConfig.set_wise_questions) {
                const setwiseQuestions = verticalConfig.set_wise_questions;
                if (verticalConfig && !autoCalConfig.is_horizontal) {
                    finalAdminLevelResponse = JSON.parse(JSON.stringify(props.question.question_admin_responses));
                    if(finalAdminLevelResponse && finalAdminLevelResponse.length>0)
                    { 
                        for (let setNo = 1; props.question.class_type >= setNo; setNo++) {
                            if (verticalConfig.operator && setwiseQuestions &&
                                setwiseQuestions.length === props.question.class_type &&
                                setwiseQuestions[setNo - 1] && setwiseQuestions[setNo - 1].question_ids.length > 0) {
    
                                let calculatedValue: any = 0;
                                const questionIds = setwiseQuestions[setNo - 1].question_ids;                                  
                                switch (verticalConfig.operator) {
                                    case "+":
                                        {       

                                                for (let adminLevelIndex = 0; finalAdminLevelResponse[0].length > adminLevelIndex; adminLevelIndex++) {
                                                    calculatedValue = 0;
                                                    for (let questionIndex = 0; questionIds.length > questionIndex; questionIndex++) {
                                                        const questionId = questionIds[questionIndex];
                                                        const responses: any = this.getQuestionResponsesById(questionId);
    
                                                        if (responses && responses[setNo - 1] && responses[setNo - 1][adminLevelIndex]) {
                                                            if (isNaN(parseInt(responses[setNo - 1][adminLevelIndex].value, 10))) {
                                                                calculatedValue += 0;
                                                                finalAdminLevelResponse[setNo - 1][adminLevelIndex].value = calculatedValue.toString();
                                                            }
                                                            else {
                                                                calculatedValue += parseInt(responses[setNo - 1][adminLevelIndex].value, 10);
                                                                finalAdminLevelResponse[setNo - 1][adminLevelIndex].value = calculatedValue.toString();
                                                            }
                                                        }
                                                    }
                                                }   
                                        }
                                        break;
                                    case "-":
                                        {
                                            let value;
                                          
                                            for (let adminLevelIndex = 0; finalAdminLevelResponse[0].length > adminLevelIndex; adminLevelIndex++) {
                                                calculatedValue = 0;
                                                for (let questionIndex = 0; questionIds.length > questionIndex; questionIndex++) {
                                                    const questionId = questionIds[questionIndex];
                                                    const responses: any = this.getQuestionResponsesById(questionId);
                                                    if (responses && responses[setNo - 1]) {
                                                        if (isNaN(parseInt(responses[setNo - 1][adminLevelIndex].value, 10))) {
                                                            if (value === undefined || value === null) {
                                                                calculatedValue = 0;
                                                                value = calculatedValue;
                                                            }
                                                            else {
                                                                calculatedValue -= 0;
                                                            }
                                                            finalAdminLevelResponse[setNo - 1][adminLevelIndex].value = calculatedValue.toString();
                                                        }
                                                        else {
                                                            if (value === undefined || value === null) {
                                                                calculatedValue = parseInt(responses[setNo - 1][adminLevelIndex].value, 10);
                                                                value = calculatedValue;
                                                            }
                                                            else {
                                                                calculatedValue -= parseInt(responses[setNo - 1][adminLevelIndex].value, 10);
                                                            }
    
                                                            finalAdminLevelResponse[setNo - 1][adminLevelIndex].value = calculatedValue.toString();
                                                        }
                                                    }
                                                }
                                            }                                           
                                        }
                                        break;
                                    case "%":
                                        {
                                            if (questionIds && questionIds.length === 2) {
                                                const questionOneResponses: any = this.getQuestionResponsesById(questionIds[0]);
                                                const questionTwoResponses: any = this.getQuestionResponsesById(questionIds[1]);
                                                if (questionOneResponses && questionTwoResponses && !isNaN(parseInt(questionOneResponses[setNo - 1], 10)) && !isNaN(parseInt(questionTwoResponses[setNo - 1], 10))) {
                                                    const unroundedValue = (parseInt(questionOneResponses[setNo - 1], 10) / parseInt(questionTwoResponses[setNo - 1], 10)) * 100;
                                                    if (!Number.isNaN(unroundedValue)) {
                                                        const rounded = Math.round(unroundedValue * 10) / 10;
                                                        calculatedValue = rounded.toFixed(1);
                                                    }
                                                    else {
                                                        calculatedValue = 0;
                                                    }
                                                }
                                                else {
                                                    calculatedValue = 0
                                                }
                                            }
    
                                        }
                                        break;
                                    case "%of":
                                        {
                                            if (questionIds && questionIds.length === 2) {
                                                const questionOneResponses: any = this.getQuestionResponsesById(questionIds[0]);
                                                const questionTwoResponses: any = this.getQuestionResponsesById(questionIds[1]);
                                                if (questionOneResponses && questionTwoResponses && !isNaN(parseInt(questionOneResponses[setNo - 1], 10)) && !isNaN(parseInt(questionTwoResponses[setNo - 1], 10))) {
                                                    const unroundedValue = (parseInt(questionOneResponses[setNo - 1], 10) / 100) * parseInt(questionTwoResponses[setNo - 1], 10);
                                                    if (!Number.isNaN(unroundedValue)) {
                                                        const rounded = Math.round(unroundedValue * 10) / 10;
                                                        calculatedValue = rounded.toFixed(1);
                                                    }
                                                    else {
                                                        calculatedValue = 0;
                                                    }
                                                }
                                                else {
                                                    calculatedValue = 0
                                                }
                                            }
                                        }
                                        break;
                                }

                                const previousResponse=JSON.stringify(adminLevelQuestion.question_admin_responses);
                                const updatedResponse=JSON.stringify(finalAdminLevelResponse);
                                    if(previousResponse!==updatedResponse){
                                        adminLevelQuestion.question_admin_responses = finalAdminLevelResponse;
                                    this.setState({
                                        questionAdminLevelResponse: adminLevelQuestion
    
                                    }, () => {                                                            
                                        updateAdminLevelQuestionDataValue(this.props, this.state.questionAdminLevelResponse.class_type, false, false, null, true, [], this.state.questionAdminLevelResponse)                               
                                    
                                    })
    
                                }   
                            }
                        }
                    }
                   
                }
            }
        }
    }

    // checking and showing validation warning messages as per configuration
    validationConditionCheck = (question: any, value: any) => {
        let validationMessage = '';
        for (const validation of question.validations) {
            const validatorValue = validation.value && validation.value.length > 0 ? parseInt(validation.value, 10) : 0;
            const inputValue = value && value.length > 0 ? parseInt(value, 10) : 0;

            switch (validation.operator) {
                case "=":
                    validationMessage = validatorValue === inputValue ? validation.message.en : '';
                    break;
                case "!=":
                    validationMessage = validatorValue !== inputValue ? '' : validation.message.en;
                    break;
                case ">":
                    validationMessage = validatorValue > inputValue ? '' : validation.message.en;
                    break;
                case "<":
                    validationMessage = validatorValue < inputValue ? '' : validation.message.en;
                    break;
                case ">=":
                    validationMessage = validatorValue >= inputValue ? '' : validation.message.en;
                    break;
                case "<=":
                    validationMessage = validatorValue <= inputValue ? '' : validation.message.en;
                    break;
                default:
                    validationMessage = '';
                    break;
            }

            if (validationMessage.length !== 0) {
                return validationMessage
            }
        }

        return validationMessage;
    }

    AdminLevelTotalFieldDisable = (questionAdminResponses: any) => {
        let isTotalDisable = true;
        for (const disable of questionAdminResponses) {
            if (disable.unavailable !== true && disable.adminLevel !== 'Total') {
                isTotalDisable = false;
                return isTotalDisable
            }
        }
        return isTotalDisable;
    }

    render() {
        let isAutoCalculatedQuestion = false;

        const autoCalConfig = this.props.question.auto_calculation_config;
        if (autoCalConfig && autoCalConfig.vertical_config) {
            const verticalConfig = autoCalConfig.vertical_config;
            if (verticalConfig.set_wise_questions) {
                const setwiseQuestions = verticalConfig.set_wise_questions;
                if (verticalConfig && !autoCalConfig.is_horizontal) {
                    const questionIds = setwiseQuestions[0].question_ids;
                    if (questionIds && questionIds.length > 0) {
                        isAutoCalculatedQuestion = true;
                    }
                }

            }
        }

        /* if (autoCalConfig && autoCalConfig.is_horizontal && autoCalConfig.horizontal_config)  {
            const horizontalConfig = autoCalConfig.horizontal_config;
            if (horizontalConfig.set_wise_questions) {
                const setwiseQuestions = horizontalConfig.set_wise_questions;
                if (horizontalConfig && !autoCalConfig.is_horizontal) {
                    const questionIds = setwiseQuestions[0].question_ids;
                    if (questionIds && questionIds.length > 0) {
                        isAutoCalculatedQuestion = true;
                    }
                }

            }
        } */

        const classTypes = [0, 1, 2];
        return (
            <>
                <>
                    {
                        <Grid container={true} item={true} spacing={24} className="pb-0">
                            {
                                classTypes.map((classTypeIndex) => {
                                    return <Grid key={'dv_' + classTypeIndex} sm={4} item={true} className="pb-0">
                                        < p key={'p_' + classTypeIndex}>{classTypeIndex === 0 ? this.props.question.question_one_title.en :
                                            (classTypeIndex === 1 ? this.props.question.question_two_title.en : this.props.question.question_three_title.en)}</p>
                                    </Grid>
                                })
                            }
                        </Grid>
                    }
                </>
                <>
                    {
                        this.props.questionAdminLevelResponse && this.props.questionAdminLevelResponse.question_admin_responses.length > 0 &&
                        this.props.questionAdminLevelResponse.question_admin_responses.map((questionAdminResponses: any, classTypeIndex: number) => {
                            return <Grid key={'dv_' + classTypeIndex} sm={4} item={true} className="pt-0">
                                {
                                    questionAdminResponses.map((questionItem: any, index: number) => {
                                        let isLimit = false;
                                        const validationMessage = this.validationConditionCheck(this.props.question, questionItem ? questionItem.value : null)
                                        const questionUnavailable = questionItem ? questionItem.unavailable : null;
                                        const disableAdminLevelTotal = this.AdminLevelTotalFieldDisable(questionAdminResponses)
                                        if (this.props.question.limit) {
                                            const inputValue = questionItem.value ? parseInt(questionItem.value, 10) : 0;
                                            const maxValue = this.props.question.max_value ? parseInt(this.props.question.max_value, 10) : 0;
                                            const minValue = this.props.question.min_value ? parseInt(this.props.question.min_value, 10) : 0;

                                            if (inputValue < minValue || inputValue > maxValue) {
                                                isLimit = true
                                            }
                                        }
                                    if (questionItem !== null){
                                        if (questionItem.adminLevel === 'Total') {

                                            if (this.props.isAutoCalculate && questionUnavailable === false) {
                                                return <Grid key={index} item={true} xs={12} className="admin-question-column">

                                                    <FormControl margin="normal" fullWidth={true}>

                                                        <TextField
                                                            margin="normal"
                                                            label={questionItem.adminLevel}
                                                            variant="outlined"
                                                            type="number"
                                                            name={"adminLevel_" + index + '_' + classTypeIndex}
                                                            key={"adminLevel_" + index + '_' + classTypeIndex}
                                                            value={questionItem.value === '0' ? '' : questionItem.value}
                                                            disabled={isAutoCalculatedQuestion || (this.props.surveyStatus === SurveyStatusEnum.Finished ? true : questionItem.unavailable ? true : false)}
                                                            autoFocus={false}
                                                            className={(isAutoCalculatedQuestion || this.props.surveyStatus === SurveyStatusEnum.Finished || questionItem.unavailable || !disableAdminLevelTotal) ? "disabledField" : ''}
                                                            onChange={(event: any) => this.props.onAdminLevelTotalAnswerChange(event, index, classTypeIndex)}
                                                            onBlur={(event: any) => this.props.onAnswerBlur(event)}
                                                            onKeyPress={(event: any) => handleKeyPress(event)}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            }
                                            else {
                                                return <></>
                                            }
                                        }
                                        else {
                                            return <Grid key={index} item={true} xs={12} className="admin-question-column">
                                                <FormControl margin="normal" fullWidth={true}>

                                                    <TextField
                                                        margin="normal"
                                                        label={questionItem.adminLevel}
                                                        variant="outlined"
                                                        type="number"
                                                        name={"adminLevel_" + index + '_' + classTypeIndex}
                                                        key={"adminLevel_" + index + '_' + classTypeIndex}
                                                        value={questionItem.value === '0' ? '' : questionItem.value}
                                                        disabled={isAutoCalculatedQuestion || (this.props.surveyStatus === SurveyStatusEnum.Finished ? true : questionItem.unavailable ? true : false)}
                                                        autoFocus={false}
                                                        className={(isAutoCalculatedQuestion || this.props.surveyStatus === SurveyStatusEnum.Finished || questionItem.unavailable) ? "disabledField" : ''}
                                                        onChange={(event: any) => this.props.onAdminLevelAnswerChange(event, index, classTypeIndex)}
                                                        onBlur={(event: any) => this.props.onAnswerBlur(event)}
                                                        onKeyPress={(event: any) => handleKeyPress(event)}
                                                    />
                                                    {
                                                        this.props.question.show_unavailable_checkbox && !isAutoCalculatedQuestion &&
                                                        <FormControlLabel key={index + "_" + "Unavailable"}
                                                            control={
                                                                <Checkbox
                                                                    disabled={this.props.surveyStatus === SurveyStatusEnum.Finished}
                                                                    name={"adminLevel_unavailable" + index + '_' + classTypeIndex}
                                                                    key={"adminLevel_unavailable" + index + '_' + classTypeIndex}
                                                                    value={"Unavailable"}
                                                                    checked={questionItem.unavailable}
                                                                    onChange={(event: any) => this.props.onUncheckedChange(event, index, classTypeIndex)}
                                                                    color="primary"
                                                                />
                                                            }
                                                            label="Unavailable"
                                                        />
                                                    }
                                                    {
                                                        this.props.question.limit && isLimit &&
                                                        <div key={index + "_" + "limit"} className="warningMessage">
                                                            <span className="warningMessageIcon">
                                                                <WarningIcon />
                                                            </span>
                                                            <label> Response must be between {this.props.question.min_value} - {this.props.question.max_value}  </label>
                                                        </div>
                                                    }
                                                    {
                                                        this.props.question.validations && this.props.question.validations.length > 0 && validationMessage &&
                                                        <div key={index + "_" + "limit"} className="warningMessage">
                                                            <span className="warningMessageIcon">
                                                                <WarningIcon />
                                                            </span>
                                                            <label> {validationMessage} </label>
                                                        </div>
                                                    }
                                                </FormControl>
                                            </Grid>
                                        }
                                    }
                                    else{return <></>}
                                    })
                                }
                            </Grid>
                        })
                    }

                </>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/responses/QuestionTypes/AdminLevelTypeQuestionComponent.tsx